import React from 'react'
import CustomButton from 'lib/ui/Button/CustomButton'
import styled from 'styled-components'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import {useTheme} from 'styled-components'

export default function BackButton(props: {
  onClick: () => void
  className?: string
  'aria-label'?: string
}) {
  const theme = useTheme()

  return (
    <StyledButton
      className={props.className}
      variant="text"
      onClick={props.onClick}
      textColor={theme.colors.primary}
      aria-label={props['aria-label']}
    >
      <BackIcon />
      back
    </StyledButton>
  )
}

const BackIcon = styled(ArrowBackIosIcon)`
  font-size: 12px !important;
  margin-top: 2px;
`

const StyledButton = styled(CustomButton)`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing[2]}!important;
`
